<template>
  <div class="en-trigger en-trigger--kosexa-tienda" :class="mode === 'embedded' ? 'en-trigger--embedded' : `en-trigger--${variant}`">
    <template v-if="mode === 'trigger'">
      <Button
        type="button"
        icon="pi pi-book"
        :class="['p-button-text', 'en-btn', variant === 'bar' ? 'en-btn--tienda-bar' : '']"
        v-tooltip.bottom="'Cuaderno de errores: acumule fallos mientras prueba, copie el texto o abra ticket SNAT.'"
        :aria-label="`Cuaderno de errores${count ? `, ${count} registros` : ''}`"
        @click="open = true"
      >
        <span v-if="count" class="en-badge" aria-hidden="true">{{ count > 99 ? '99+' : count }}</span>
      </Button>

      <Sidebar
        v-model:visible="open"
        position="right"
        :modal="true"
        :dismissable="true"
        :show-close-icon="true"
        class="en-sidebar"
        :style="{ width: 'min(36rem, 94vw)' }"
      >
        <ErrorNotebookInner />
      </Sidebar>
    </template>
    <ErrorNotebookInner v-else />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Button from 'primevue/button';
import Sidebar from 'primevue/sidebar';
import Tooltip from 'primevue/tooltip';
import ErrorNotebookInner from '@/components/ErrorNotebookInner.vue';

export default {
  name: 'ErrorNotebookTrigger',
  directives: { tooltip: Tooltip },
  components: { Button, Sidebar, ErrorNotebookInner },
  props: {
    variant: {
      type: String,
      default: 'bar',
      validator: (v) => ['bar', 'login', 'floating'].includes(v),
    },
    /** 'trigger': botón + sidebar. 'embedded': solo contenido (panel unificado SNAT). */
    mode: {
      type: String,
      default: 'trigger',
      validator: (v) => ['trigger', 'embedded'].includes(v),
    },
  },
  data() {
    return {
      open: false,
    };
  },
  computed: {
    ...mapGetters('errorNotebook', ['count']),
  },
};
</script>

<style scoped>
.en-trigger {
  position: relative;
  display: inline-flex;
  align-items: center;
}

.en-trigger--embedded {
  display: block;
  width: 100%;
}

.en-btn {
  position: relative;
  color: inherit !important;
}

.en-trigger--bar .en-btn--tienda-bar {
  border-radius: 50% !important;
  min-width: 44px;
  min-height: 44px;
  padding: 0.5rem !important;
  color: var(--text-color) !important;
}

.en-trigger--bar .en-btn--tienda-bar:hover {
  color: var(--primary-color) !important;
  background-color: rgba(201, 169, 98, 0.12) !important;
}

.en-trigger--login .en-btn,
.en-trigger--floating .en-btn {
  color: #1e293b !important;
  background: rgba(255, 255, 255, 0.92) !important;
  border-radius: 999px !important;
  box-shadow: 0 2px 12px rgba(15, 23, 42, 0.12);
}

.en-badge {
  position: absolute;
  top: -2px;
  right: -2px;
  min-width: 1.1rem;
  height: 1.1rem;
  padding: 0 0.28rem;
  font-size: 0.65rem;
  font-weight: 800;
  line-height: 1.1rem;
  text-align: center;
  border-radius: 999px;
  background: #b91c1c;
  color: #fff;
  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.9);
  pointer-events: none;
}

.en-trigger--login .en-badge,
.en-trigger--floating .en-badge {
  box-shadow: 0 0 0 2px rgba(45, 139, 254, 0.35);
}

:deep(.en-sidebar .p-sidebar-content) {
  padding-top: 0.5rem;
}
</style>
